import { CenterScreenModal } from '../atoms'
import { useOpeningElementsControllerContext, useUserLanguage } from '@/customHooks'
import { CreateOwnerForm } from '../organism';
import { Col, Row } from 'react-grid-system';
import { FetchResult } from '@apollo/client';
import { CreateOwnerMutation, UpdateOwnerMutation } from '@/graphql/generated';

const textsData = {
  en: {
    title: 'Create an Owner',
    confirmation: {
      create: {
        title: 'Owner has been created',
        description: (firstName: string, lastName: string) => `User ${firstName} ${lastName} has been created succesfully`,
      },
      update: {
        title: 'Owner has been updated',
        description: (firstName: string, lastName: string) => `User ${firstName} ${lastName} has been updated succesfully`,
      }
    }
  },
  es: {
    title: 'Crear a un Propietario',
    confirmation: {
      create: {
        title: 'Propietario creado con éxito',
        description: (firstName: string, lastName: string) => `${firstName} ${lastName} fue creado con éxito`,
      },
      update: {
        title: 'Propietario actualizado con exito',
        description: (firstName: string, lastName: string) => `${firstName} ${lastName} fue actualizado con éxito`,
      }
    }
  }
}

export const CreateOwnerFormModal = () => {
  const { state, createOwnerFormModalClose, confirmDialogModalOpen} = useOpeningElementsControllerContext();

  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const onCreateSuccess = (response: FetchResult<CreateOwnerMutation> | FetchResult<UpdateOwnerMutation>) => {
    if (response.data && 'createOwner' in response.data) {
      const user = response.data?.createOwner
      if (user.__typename === 'OwnerOutput') {
        createOwnerFormModalClose()
        confirmDialogModalOpen({
          title: texts.confirmation.create.title,
          description: texts.confirmation.create.description(user.firstName, user.lastName),
        })
      }
    }
    else if (response.data && 'updateOwner' in response.data) {
      const user = response.data?.updateOwner
      createOwnerFormModalClose()
      confirmDialogModalOpen({
        title: texts.confirmation.update.title,
        description: texts.confirmation.update.description(user.firstName, user.lastName)
      })
    } 
  }
  return (
    <CenterScreenModal
      isOpen={state.isCreateOwnerFormModalOpen}
      onClose={createOwnerFormModalClose}
    >
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <CreateOwnerForm
        ownerDetail={null}
        activity="creating"
        onSuccess={onCreateSuccess}
      />   
    </CenterScreenModal>
  )
}
